import React from "react";

const Text2 = () => {

  React.useEffect(() => {
    // 👇️ scroll to top on page load, behavior can be snappy with 'auto'
    document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });}
    , []);
    return(
      <>
        <p className="content-heading" id="top">
        Vad är lönsamhet?
      </p>

      <div className="content-text mt-4">
        <p>
          När ett företag <i>säljer</i> en vara eller tjänst uppstår en <i>Inkomst</i>.<br/>
          När ett företag <i>köper</i> en vara eller tjänst uppstår en <i>Utgift</i>.                
        </p>
        <p>
          Lönsamhet är det som återstår då företagets utgifter dras från inkomsterna.                   
        </p>
        <p>
          <i>Inkomst - Utgift = Lönsamhet </i>                
        </p>
        <p>
          Det är ur företagets lönsamhet som din (och medarbetares) lön finansieras. Alltså                    
        </p>
        <p className="ms-4">
          -<span className="strong"> Låg</span> lönsamhet i verksamheten <span className="strong">begränsar </span> 
          ditt löneuttag <br/>
          -<span className="strong"> Hög</span> lönsamhet medger <span className="strong">ökat löneuttag</span>                 
        </p>
        
        <p className="heading2 mt-4">
          Periodiserad lönsamhet                    
        </p>
        <p>
          I bokföringen brukar företags inkomster och utgifter periodiseras och de kallas då <i>Intäkt</i> respektive
          <i> Utgift</i>                    
        </p>
        <p> 
          Alltså samma formel som ovan - med utbytta beteckingar.                      
        </p>
        <p className="ms-4">
          <i>Intäkt - Kostnad = Lönsamhet</i>                      
        </p>
        <p>
          Kostnad kan vara antingen <i>rörlig</i> eller <i>fast</i>.                      
        </p>
        
        <p className="ms-4">
          En <i>Rörlig Kostnad</i> växer och krymper med produktens tillverknings- och försäljnings-volym. 
          Exempelvis material, tillverkning, förpackning, leverans, agentprovision. 
        </p>
        <p className="ms-4 mt-3">
          En <i>Fast Kostnad</i> varierar sällan direkt med tillverkning och försäljning utan språngvis. 
          Exempelvis: lön, lokalhyra, städning, internet, reklamkampanj, försäkring. 
        </p>
                     
          
      </div>
    </>
  );
}
export default Text2;